const ASSETS = "/assets/club";

export const LOGO = `${ASSETS}/logo.png`;
export const LOGO_EXPRESSO = `${ASSETS}/expresso-racing.png`;

export const isVideo = (src) => /\.(mp4|webm|mov)$/i.test(src || "");

export const IMAGES = {
  hero: `${ASSETS}/hero.jpg`,
  feminine: `${ASSETS}/equipe-feminine.mp4`,
  masculine: `${ASSETS}/equipe-masculine.mp4`,
  ecole: `${ASSETS}/ecole-velo.mp4`,
  gear: "https://images.pexels.com/photos/7905463/pexels-photo-7905463.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const NAV_ITEMS = [
  { label: "Accueil", to: "/" },
  {
    label: "Le Club",
    to: "/le-club",
    children: [
      { label: "Histoire", to: "/histoire" },
      { label: "Le projet du club", to: "/projets/projet-sportif" },
      { label: "Formation", to: "/le-club#formation" },
    ],
  },
  {
    label: "Nos Équipes",
    to: "/equipes",
    children: [
      { label: "Équipe féminine N1/UCI", to: "/equipes/feminine" },
      { label: "Équipe homme N3", to: "/equipes/masculine" },
      { label: "L'école de vélo", to: "/equipes/jeunes" },
      { label: "Loisir et cyclo", to: "/equipes/loisir" },
    ],
  },
  { label: "Actualités", to: "/actualites" },
  { label: "Calendrier", to: "/calendrier" },
  { label: "Résultats", to: "/resultats" },
  { label: "Partenaires", to: "/partenaires" },
  { label: "Contact", to: "/contact" },
];

export const TEAMS = {
  feminine: {
    slug: "feminine",
    name: "Équipe Féminine N1/UCI",
    short: "Féminine N1/UCI",
    category: "Équipe féminine",
    kicker: "Compétition",
    image: IMAGES.feminine,
    position: "center 35%",
    presentation: {
      tagline: "Une équipe. Une ambition. Un avenir à construire.",
      paragraphs: [
        "Depuis 2012, le Club Cycliste Le Boulou développe un projet dédié au cyclisme féminin.",
        "Au fil des saisons, le club a accompagné des coureuses vers les titres nationaux, les sélections en équipe de France et le haut niveau international. Cette expérience constitue aujourd'hui une force pour construire la suite.",
        "Aujourd'hui, nous regardons vers l'avenir. Notre ambition est de construire une équipe féminine ambitieuse, compétitive et humaine, capable de faire progresser ses coureuses et de leur donner les moyens d'exprimer pleinement leur potentiel.",
        "Nous voulons créer un environnement où chaque coureuse peut progresser, prendre des responsabilités, gagner en confiance et se rapprocher de ses objectifs.",
      ],
      callout: {
        title: "Un projet pour celles qui veulent aller plus loin",
        paragraphs: [
          "Tu veux franchir un cap ? Tu recherches un projet sportif ambitieux ? Tu veux évoluer dans un collectif où la performance se construit ensemble ?",
          "Le Club Cycliste Le Boulou veut accueillir celles qui ont envie de progresser et de construire l'avenir avec nous.",
          "Notre histoire nous a construits. Notre ambition nous pousse vers l'avenir.",
        ],
      },
    },
    staff: [
      { role: "Manager / Directeur sportif", names: "Stéphane Roger" },
      { role: "Mécanicien", names: "Roger Roger · Becaye Traoré" },
      { role: "Assistant", names: "Laurent Bailloeuil · Mariane Mouchoux" },
      { role: "Diététicienne", names: "Vanessa Mouchoux" },
    ],
    videoSuivre: `${ASSETS}/feminine-suivre.mp4`,
  },
  masculine: {
    slug: "masculine",
    name: "Équipe Homme N3",
    short: "Homme N3",
    category: "Équipe masculine",
    kicker: "Expresso Racing",
    sponsor: "Expresso Racing",
    image: IMAGES.masculine,
    position: "center 20%",
    presentation: {
      tagline: "Un nouveau projet. Une nouvelle ambition.",
      paragraphs: [
        "En 2026, le Club Cycliste Le Boulou franchit une nouvelle étape avec la création d'Expresso Racing, son équipe masculine engagée en Nationale 3.",
        "Cette nouvelle équipe vient renforcer la filière compétition du club et offrir aux coureurs un cadre structuré pour progresser, se confronter au niveau national et construire leurs ambitions sportives.",
        "Notre objectif est de construire un collectif compétitif, solidaire et ambitieux, où chacun peut prendre sa place, progresser et contribuer aux résultats de l'équipe.",
        "Expresso Racing doit également être un tremplin pour les jeunes coureurs et ceux qui souhaitent franchir un cap, avec l'ambition de faire grandir progressivement le projet et de regarder vers les niveaux supérieurs.",
      ],
      callout: {
        title: "Un collectif avant tout",
        paragraphs: [
          "Les résultats sont importants, mais ils sont la conséquence d'un projet collectif.",
          "Travail, engagement, solidarité et plaisir de courir ensemble sont au cœur de notre philosophie.",
          "Construire aujourd'hui l'équipe qui fera demain.",
        ],
      },
    },
    staff: [
      { role: "Manager", names: "Stéphane Roger" },
      { role: "Directeur sportif", names: "Francis Roger · Antoine" },
      { role: "Mécanicien", names: "Roger Roger · Becaye Traoré" },
      { role: "Assistant", names: "Laurent Bailloeuil · Mariane Mouchoux" },
      { role: "Diététicienne", names: "Vanessa Mouchoux" },
    ],
  },
  jeunes: {
    slug: "jeunes",
    name: "L'École de Vélo",
    short: "École de Vélo",
    category: "Jeunes",
    kicker: "Formation",
    image: IMAGES.ecole,
    position: "center 45%",
    presentation: {
      tagline: "Apprendre. Progresser. S'épanouir.",
      paragraphs: [
        "Depuis de nombreuses années, l'école de vélo du Club Cycliste Le Boulou accompagne les jeunes dans leur découverte et leur apprentissage du cyclisme.",
        "Ici, on apprend d'abord à aimer le vélo, à maîtriser sa machine, à progresser et à partager avec les autres. Les enfants évoluent à leur rythme dans un environnement encadré, sportif et convivial.",
        "Notre école accueille les jeunes qui souhaitent simplement découvrir le vélo comme ceux qui veulent progressivement s'orienter vers la compétition.",
      ],
      callout: {
        title: "Une école pour grandir avec le vélo",
        paragraphs: [
          "Apprentissage, jeux, technique, sorties, premières compétitions… chaque étape permet aux jeunes de gagner en autonomie et en confiance.",
          "L'objectif est de transmettre les bases du cyclisme, le goût de l'effort, le respect des autres et surtout le plaisir de rouler ensemble.",
          "Notre école a également une histoire sportive forte : en 2014, le Club Cycliste Le Boulou a remporté le titre de Champion du Languedoc-Roussillon des écoles de vélo à Mende.",
          "Mais notre plus belle réussite reste de voir les enfants progresser, prendre confiance et continuer leur chemin avec le vélo. Aujourd'hui à l'école de vélo, demain peut-être sur les routes du monde.",
        ],
      },
    },
    staff: [
      { role: "Entraîneur diplômé d'État", names: "Gabriel Roger" },
      { role: "Entraîneur expert", names: "Stéphane Roger" },
      { role: "Entraîneur club", names: "Maria D'Ambrosio" },
      { role: "Encadrement", names: "Becaye Traoré · Laurent Cartula · Jérome Lamargot · Francis Roger" },
    ],
    videoSuivre: `${ASSETS}/ecole-velo-suivre.mp4`,
  },
  loisir: {
    slug: "loisir",
    name: "Loisir et Cyclo",
    short: "Loisir",
    category: "Vie du club",
    kicker: "Rouler ensemble",
    image: IMAGES.hero,
    position: "center 60%",
    presentation: {
      tagline: "Rouler ensemble, progresser et se faire plaisir.",
      paragraphs: [
        {
          h: "Cyclo — Rouler en groupe, progresser et se faire plaisir",
          t: "Pour celles et ceux qui souhaitent un cadre plus régulier, le groupe Cyclo propose des sorties d'entraînement loisir, avec un objectif simple : rouler ensemble, progresser et passer un bon moment.",
        },
        {
          h: "Loisir — Le vélo pour tous",
          t: "Pour les femmes comme pour les hommes, notre pratique loisir permet de rouler sans objectif de compétition : des sorties, des découvertes, du partage et du plaisir.",
        },
      ],
      callout: {
        title: "Les femmes, osez nous rejoindre !",
        paragraphs: [
          "Vous êtes une fille, une jeune femme, une maman ou simplement une femme qui aimerait commencer ou reprendre le vélo ? N'ayez pas peur de venir nous rencontrer !",
          "Pas besoin d'être une cycliste expérimentée, de savoir rouler en groupe ou d'avoir déjà fait de la compétition. Que vous soyez débutante, que vous repreniez le vélo après plusieurs années ou que vous cherchiez simplement un groupe avec lequel partager votre passion, vous êtes la bienvenue.",
          "Nous voulons créer un environnement où chacune peut prendre confiance, progresser à son rythme et surtout prendre du plaisir à rouler. Le plus difficile, c'est parfois de faire le premier pas. Après, on roule ensemble.",
        ],
      },
    },
  },
};

export const SOCIALS = [
  { label: "Facebook", href: "#", network: "facebook" },
  { label: "Instagram", href: "#", network: "instagram" },
];
